import { Card } from '@totalsoft/rocket-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

function Forbidden() {
  const { t } = useTranslation();

  return <Card>{t('Forbidden')}</Card>;
}

Forbidden.propTypes = {};

export default Forbidden;
